function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 716.218,
    height: 345.448,
    viewBox: "0 0 189.499 91.4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#198754",
      strokeWidth: 0.264583
    },
    d: "M20.766 22.07c-8.222 8.222-7.158 21.506-7.113 35.16.05 15.67-.977 30.047 8.7 39.725 8.828 8.827 22.189 7.59 36.499 7.712 14.71.125 28.785 1.361 37.858-7.712 9.091-9.092 7.337-23.743 7.194-38.481-.14-14.28 1.615-28.654-7.194-37.463-8.927-8.927-23.207-7.53-37.68-7.553-14.549-.024-29.29-.362-38.264 8.611Zm43.654 3.71c8.437 0 14.586.75 18.446 2.25v8.336c-5.054-2.588-11.541-3.881-19.46-3.881-2.19 0-4.379.176-6.567.529-2.19.323-4.14.867-5.85 1.632-1.712.764-3.105 1.75-4.18 2.955-1.074 1.205-1.612 2.676-1.612 4.41 0 1.618.399 3.014 1.195 4.19.835 1.176 2.049 2.25 3.64 3.22 1.593.97 3.523 1.911 5.792 2.823 2.308.911 4.954 1.911 7.94 3a128.974 128.974 0 0 1 8.715 3.528c2.746 1.235 5.154 2.602 7.223 4.101 2.07 1.5 3.701 3.16 4.895 4.984 1.234 1.823 1.85 3.91 1.85 6.263 0 3.117-.835 5.763-2.507 7.94-1.631 2.146-3.86 3.895-6.686 5.247-2.785 1.353-6.009 2.323-9.67 2.911-3.662.618-7.522.927-11.582.927-1.353 0-3.024-.088-5.014-.265a75.434 75.434 0 0 1-6.089-.706 66.566 66.566 0 0 1-5.91-1.102c-1.83-.47-3.303-.985-4.417-1.544v-8.733c1.353.882 2.965 1.676 4.835 2.382a53.38 53.38 0 0 0 5.97 1.808c2.109.47 4.218.838 6.327 1.103 2.11.265 4.06.397 5.85.397 6.17 0 10.766-.838 13.79-2.514 3.065-1.706 4.597-4.146 4.597-7.322 0-1.705-.517-3.19-1.552-4.454-.995-1.265-2.388-2.411-4.179-3.44-1.79-1.059-3.92-2.059-6.387-3a388.795 388.795 0 0 0-7.88-3.043 153.11 153.11 0 0 1-8.358-3.396C45 56.169 42.75 54.905 40.84 53.523c-1.91-1.382-3.423-2.94-4.537-4.675-1.075-1.765-1.612-3.823-1.612-6.175 0-2.882.856-5.38 2.567-7.498 1.711-2.146 3.96-3.91 6.746-5.293 2.785-1.382 5.95-2.41 9.491-3.087a58.757 58.757 0 0 1 10.925-1.014z",
    transform: "translate(-13.585 -13.391)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "38.1px",
      fontFamily: "'Yu Gothic UI'",
      InkscapeFontSpecification: "'Yu Gothic UI'",
      fill: "#198754",
      strokeWidth: 0.264583
    },
    x: 107.481,
    y: 54.194,
    transform: "translate(-13.585 -13.391)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontFamily: "'Yu Gothic UI'",
      InkscapeFontSpecification: "'Yu Gothic UI'",
      fill: "#198754",
      strokeWidth: 0.264583
    },
    x: 107.481,
    y: 54.194
  }, "tream")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "38.1px",
      fontFamily: "'Yu Gothic UI'",
      InkscapeFontSpecification: "'Yu Gothic UI'",
      fill: "#198754",
      strokeWidth: 0.264583
    },
    x: 108.562,
    y: 88.423,
    transform: "translate(-13.585 -13.391)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontFamily: "'Yu Gothic UI'",
      InkscapeFontSpecification: "'Yu Gothic UI'",
      fill: "#198754",
      strokeWidth: 0.264583
    },
    x: 108.562,
    y: 88.423
  }, "aver")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5fde5658b75cfa50a7fbe742d4cda47a.svg";
export { ForwardRef as ReactComponent };